export const BROWSER = typeof window !== 'undefined'
export const CustomerMobile = '400-001-8852'
export const CustomerMobileCall = '4000018852'
